<template>
    <FilterFlyout
        :name="$t('results.filtering.whichFeeTypes')"
        :isActive="filterActive"
        :isModified="filterModified"
        @save="save"
        @clear="clear"
    >
        <div class="row fees">
            <div class="col-6">
                <button
                    :class="['btn button bordered resubmit-option-button', { active: !editingWithoutFees }]"
                    @click="editingWithoutFees = false"
                >
                    {{ $t('results.filtering.withFees') }}
                </button>
            </div>

            <div class="col-6">
                <button
                    :class="['btn button bordered filter-option-button', { active: editingWithoutFees }]"
                    @click="editingWithoutFees = true"
                >
                    {{ $t('results.filtering.noFees') }}
                </button>
            </div>
        </div>
    </FilterFlyout>
</template>

<script>
import { useStore } from 'vuex'
import useFilterBase from '@js/composables/filterBase.js'

// lodash components
import isEmpty from 'lodash/isEmpty'

export default {
    setup() {
        const store = useStore()

        return {
            store,
            ...useFilterBase(store, 'fees'),
        }
    },

    data() {
        return {
            editingWithoutFees: this.defaultValue(),
            activeWithoutFees: this.defaultValue(),
        }
    },

    mounted() {
        this.filterState.save = this.save
        this.filterState.clear = this.clear
        this.filterState.filterItem = this.filterItem

        this.store.state.result.withoutFeesChecked = this.activeWithoutFees
    },

    computed: {
        filterModified() {
            this.filterState.isModified = this.activeWithoutFees !== this.editingWithoutFees
            return this.filterState.isModified
        },
        filterActive() {
            this.filterState.isActive = this.activeWithoutFees !== this.defaultValue()
            return this.filterState.isActive
        },
    },

    methods: {
        filterItem(offer) {
            let feesEmpty = isEmpty(offer.fees)

            if (!this.activeWithoutFees) {
                feesEmpty = !feesEmpty
            }

            return feesEmpty
        },
        save() {
            this.activeWithoutFees = this.editingWithoutFees

            this.store.state.result.withoutFeesChecked = this.activeWithoutFees

            this.trackEvent('event', {
                eventCategory: 'filtering',
                eventAction: 'submit',
                eventLabel: 'without-fees',
            })
        },
        clear() {
            this.editingWithoutFees = this.defaultValue()
            this.save()
        },
        defaultValue() {
            return true
        },
        // special case method: custom method for toggling fees from filters parent
        toggle() {
            this.editingWithoutFees = !this.activeWithoutFees
            this.save()
        },
    },
}
</script>

<style lang="scss">
@import '~scss/mixins/gutter-size';
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';
@import '~scss/settings/variables';

.fees {
    @include resize-gutter(20px);
    margin-bottom: -12px;

    .button {
        margin-bottom: 12px;
    }
}
</style>
